// fox
const FoxOk = require('./fox/fox_ok.png')
const FoxExcited = require('./fox/fox_excited.png')
const FoxSad = require('./fox/fox_sad.png')
const FoxHappy = require('./fox/fox_happy.png')
const FoxAfraid = require('./fox/fox_afraid.png')
const FoxAngry = require('./fox/fox_angry.png')
// panda
const PandaOk = require('./panda/panda_ok.png')
const PandaExcited = require('./panda/panda_excited.png')
const PandaSad = require('./panda/panda_sad.png')
const PandaHappy = require('./panda/panda_happy.png')
const PandaAfraid = require('./panda/panda_afraid.png')
const PandaAngry = require('./panda/panda_angry.png')
// tiger
const TigerOk = require('./tiger/tiger_ok.png')
const TigerExcited = require('./tiger/tiger_excited.png')
const TigerSad = require('./tiger/tiger_sad.png')
const TigerHappy = require('./tiger/tiger_happy.png')
const TigerAfraid = require('./tiger/tiger_afraid.png')
const TigerAngry = require('./tiger/tiger_angry.png')
// raccoon
const RaccoonOk = require('./raccoon/raccoon_ok.png')
const RaccoonExcited = require('./raccoon/raccoon_excited.png')
const RaccoonSad = require('./raccoon/raccoon_sad.png')
const RaccoonHappy = require('./raccoon/raccoon_happy.png')
const RaccoonAfraid = require('./raccoon/raccoon_afraid.png')
const RaccoonAngry = require('./raccoon/raccoon_angry.png')
// shark
const SharkOk = require('./shark/shark_ok.png')
const SharkExcited = require('./shark/shark_excited.png')
const SharkSad = require('./shark/shark_sad.png')
const SharkHappy = require('./shark/shark_happy.png')
const SharkAfraid = require('./shark/shark_afraid.png')
const SharkAngry = require('./shark/shark_angry.png')
// hamster
const HamsterOk = require('./hamster/hamster_ok.png')
const HamsterExcited = require('./hamster/hamster_excited.png')
const HamsterSad = require('./hamster/hamster_sad.png')
const HamsterHappy = require('./hamster/hamster_happy.png')
const HamsterAfraid = require('./hamster/hamster_afraid.png')
const HamsterAngry = require('./hamster/hamster_angry.png')
// penguin
const PenguinOk = require('./penguin/penguin_ok.png')
const PenguinExcited = require('./penguin/penguin_excited.png')
const PenguinSad = require('./penguin/penguin_sad.png')
const PenguinHappy = require('./penguin/penguin_happy.png')
const PenguinAfraid = require('./penguin/penguin_afraid.png')
const PenguinAngry = require('./penguin/penguin_angry.png')
// bear
const BearOk = require('./bear/bear_ok.png')
const BearExcited = require('./bear/bear_excited.png')
const BearSad = require('./bear/bear_sad.png')
const BearHappy = require('./bear/bear_happy.png')
const BearAfraid = require('./bear/bear_afraid.png')
const BearAngry = require('./bear/bear_angry.png')
// octopus
const OctopusOk = require('./octopus/octopus_ok.png')
const OctopusExcited = require('./octopus/octopus_excited.png')
const OctopusSad = require('./octopus/octopus_sad.png')
const OctopusHappy = require('./octopus/octopus_happy.png')
const OctopusAfraid = require('./octopus/octopus_afraid.png')
const OctopusAngry = require('./octopus/octopus_angry.png')
// dog
const DogOk = require('./dog/dog_ok.png')
const DogExcited = require('./dog/dog_excited.png')
const DogSad = require('./dog/dog_sad.png')
const DogHappy = require('./dog/dog_happy.png')
const DogAfraid = require('./dog/dog_afraid.png')
const DogAngry = require('./dog/dog_angry.png')
// bird
const BirdOk = require('./bird/bird_ok.png')
const BirdExcited = require('./bird/bird_excited.png')
const BirdSad = require('./bird/bird_sad.png')
const BirdHappy = require('./bird/bird_happy.png')
const BirdAfraid = require('./bird/bird_afraid.png')
const BirdAngry = require('./bird/bird_angry.png')
// koala
const KoalaOk = require('./koala/koala_ok.png')
const KoalaExcited = require('./koala/koala_excited.png')
const KoalaSad = require('./koala/koala_sad.png')
const KoalaHappy = require('./koala/koala_happy.png')
const KoalaAfraid = require('./koala/koala_afraid.png')
const KoalaAngry = require('./koala/koala_angry.png')
// giraffe
const GiraffeOk = require('./giraffe/giraffe_ok.png')
const GiraffeExcited = require('./giraffe/giraffe_excited.png')
const GiraffeSad = require('./giraffe/giraffe_sad.png')
const GiraffeHappy = require('./giraffe/giraffe_happy.png')
const GiraffeAfraid = require('./giraffe/giraffe_afraid.png')
const GiraffeAngry = require('./giraffe/giraffe_angry.png')
// otter
const OtterOk = require('./otter/otter_ok.png')
const OtterExcited = require('./otter/otter_excited.png')
const OtterSad = require('./otter/otter_sad.png')
const OtterHappy = require('./otter/otter_happy.png')
const OtterAfraid = require('./otter/otter_afraid.png')
const OtterAngry = require('./otter/otter_angry.png')
// deer
const DeerOk = require('./deer/deer_ok.png')
const DeerExcited = require('./deer/deer_excited.png')
const DeerSad = require('./deer/deer_sad.png')
const DeerHappy = require('./deer/deer_happy.png')
const DeerAfraid = require('./deer/deer_afraid.png')
const DeerAngry = require('./deer/deer_angry.png')
// bunny
const BunnyOk = require('./bunny/bunny_ok.png')
const BunnyExcited = require('./bunny/bunny_excited.png')
const BunnySad = require('./bunny/bunny_sad.png')
const BunnyHappy = require('./bunny/bunny_happy.png')
const BunnyAfraid = require('./bunny/bunny_afraid.png')
const BunnyAngry = require('./bunny/bunny_angry.png')
// elephant
const ElephantOk = require('./elephant/elephant_ok.png')
const ElephantExcited = require('./elephant/elephant_excited.png')
const ElephantSad = require('./elephant/elephant_sad.png')
const ElephantHappy = require('./elephant/elephant_happy.png')
const ElephantAfraid = require('./elephant/elephant_afraid.png')
const ElephantAngry = require('./elephant/elephant_angry.png')
// zebra
const ZebraOk = require('./zebra/zebra_ok.png')
const ZebraExcited = require('./zebra/zebra_excited.png')
const ZebraSad = require('./zebra/zebra_sad.png')
const ZebraHappy = require('./zebra/zebra_happy.png')
const ZebraAfraid = require('./zebra/zebra_afraid.png')
const ZebraAngry = require('./zebra/zebra_angry.png')
// sugarGlider
const SugarGliderOk = require('./sugarGlider/sugarGlider_ok.png')
const SugarGliderExcited = require('./sugarGlider/sugarGlider_excited.png')
const SugarGliderSad = require('./sugarGlider/sugarGlider_sad.png')
const SugarGliderHappy = require('./sugarGlider/sugarGlider_happy.png')
const SugarGliderAfraid = require('./sugarGlider/sugarGlider_afraid.png')
const SugarGliderAngry = require('./sugarGlider/sugarGlider_angry.png')
// leopard
const LeopardOk = require('./leopard/leopard_ok.png')
const LeopardExcited = require('./leopard/leopard_excited.png')
const LeopardSad = require('./leopard/leopard_sad.png')
const LeopardHappy = require('./leopard/leopard_happy.png')
const LeopardAfraid = require('./leopard/leopard_afraid.png')
const LeopardAngry = require('./leopard/leopard_angry.png')
// fish
const FishOk = require('./fish/fish_ok.png')
const FishExcited = require('./fish/fish_excited.png')
const FishSad = require('./fish/fish_sad.png')
const FishHappy = require('./fish/fish_happy.png')
const FishAfraid = require('./fish/fish_afraid.png')
const FishAngry = require('./fish/fish_angry.png')
// darkBear
const DarkBearOk = require('./darkBear/darkBear_ok.png')
const DarkBearExcited = require('./darkBear/darkBear_excited.png')
const DarkBearSad = require('./darkBear/darkBear_sad.png')
const DarkBearHappy = require('./darkBear/darkBear_happy.png')
const DarkBearAfraid = require('./darkBear/darkBear_afraid.png')
const DarkBearAngry = require('./darkBear/darkBear_angry.png')
// kitty
const KittyOk = require('./kitty/kitty_ok.png')
const KittyExcited = require('./kitty/kitty_excited.png')
const KittySad = require('./kitty/kitty_sad.png')
const KittyHappy = require('./kitty/kitty_happy.png')
const KittyAfraid = require('./kitty/kitty_afraid.png')
const KittyAngry = require('./kitty/kitty_angry.png')
// beaver
const BeaverOk = require('./beaver/beaver_ok.png')
const BeaverExcited = require('./beaver/beaver_excited.png')
const BeaverSad = require('./beaver/beaver_sad.png')
const BeaverHappy = require('./beaver/beaver_happy.png')
const BeaverAfraid = require('./beaver/beaver_afraid.png')
const BeaverAngry = require('./beaver/beaver_angry.png')
// frog
const FrogOk = require('./frog/frog_ok.png')
const FrogExcited = require('./frog/frog_excited.png')
const FrogSad = require('./frog/frog_sad.png')
const FrogHappy = require('./frog/frog_happy.png')
const FrogAfraid = require('./frog/frog_afraid.png')
const FrogAngry = require('./frog/frog_angry.png')
// hedgeHog
const HedgeHogOk = require('./hedgeHog/hedgeHog_ok.png')
const HedgeHogExcited = require('./hedgeHog/hedgeHog_excited.png')
const HedgeHogSad = require('./hedgeHog/hedgeHog_sad.png')
const HedgeHogHappy = require('./hedgeHog/hedgeHog_happy.png')
const HedgeHogAfraid = require('./hedgeHog/hedgeHog_afraid.png')
const HedgeHogAngry = require('./hedgeHog/hedgeHog_angry.png')
// lion
const LionOk = require('./lion/lion_ok.png')
const LionExcited = require('./lion/lion_excited.png')
const LionSad = require('./lion/lion_sad.png')
const LionHappy = require('./lion/lion_happy.png')
const LionAfraid = require('./lion/lion_afraid.png')
const LionAngry = require('./lion/lion_angry.png')
// lama
const LamaOk = require('./lama/lama_ok.png')
const LamaExcited = require('./lama/lama_excited.png')
const LamaSad = require('./lama/lama_sad.png')
const LamaHappy = require('./lama/lama_happy.png')
const LamaAfraid = require('./lama/lama_afraid.png')
const LamaAngry = require('./lama/lama_angry.png')
// owl
const OwlOk = require('./owl/owl_ok.png')
const OwlExcited = require('./owl/owl_excited.png')
const OwlSad = require('./owl/owl_sad.png')
const OwlHappy = require('./owl/owl_happy.png')
const OwlAfraid = require('./owl/owl_afraid.png')
const OwlAngry = require('./owl/owl_angry.png')
// rabbit
const RabbitOk = require('./rabbit/rabbit_ok.png')
const RabbitExcited = require('./rabbit/rabbit_excited.png')
const RabbitSad = require('./rabbit/rabbit_sad.png')
const RabbitHappy = require('./rabbit/rabbit_happy.png')
const RabbitAfraid = require('./rabbit/rabbit_afraid.png')
const RabbitAngry = require('./rabbit/rabbit_angry.png')

export const AnimalImages = {
    fox: {
        ok: FoxOk,
        excited: FoxExcited,
        sad: FoxSad,
        happy: FoxHappy,
        afraid: FoxAfraid,
        angry: FoxAngry,
    },
    panda: {
        ok: PandaOk,
        excited: PandaExcited,
        sad: PandaSad,
        happy: PandaHappy,
        afraid: PandaAfraid,
        angry: PandaAngry,
    },
    tiger: {
        ok: TigerOk,
        excited: TigerExcited,
        sad: TigerSad,
        happy: TigerHappy,
        afraid: TigerAfraid,
        angry: TigerAngry,
    },
    raccoon: {
        ok: RaccoonOk,
        excited: RaccoonExcited,
        sad: RaccoonSad,
        happy: RaccoonHappy,
        afraid: RaccoonAfraid,
        angry: RaccoonAngry,
    },
    shark: {
        ok: SharkOk,
        excited: SharkExcited,
        sad: SharkSad,
        happy: SharkHappy,
        afraid: SharkAfraid,
        angry: SharkAngry,
    },
    hamster: {
        ok: HamsterOk,
        excited: HamsterExcited,
        sad: HamsterSad,
        happy: HamsterHappy,
        afraid: HamsterAfraid,
        angry: HamsterAngry,
    },
    penguin: {
        ok: PenguinOk,
        excited: PenguinExcited,
        sad: PenguinSad,
        happy: PenguinHappy,
        afraid: PenguinAfraid,
        angry: PenguinAngry,
    },
    bear: {
        ok: BearOk,
        excited: BearExcited,
        sad: BearSad,
        happy: BearHappy,
        afraid: BearAfraid,
        angry: BearAngry,
    },
    octopus: {
        ok: OctopusOk,
        excited: OctopusExcited,
        sad: OctopusSad,
        happy: OctopusHappy,
        afraid: OctopusAfraid,
        angry: OctopusAngry,
    },
    dog: {
        ok: DogOk,
        excited: DogExcited,
        sad: DogSad,
        happy: DogHappy,
        afraid: DogAfraid,
        angry: DogAngry,
    },
    bird: {
        ok: BirdOk,
        excited: BirdExcited,
        sad: BirdSad,
        happy: BirdHappy,
        afraid: BirdAfraid,
        angry: BirdAngry,
    },
    koala: {
        ok: KoalaOk,
        excited: KoalaExcited,
        sad: KoalaSad,
        happy: KoalaHappy,
        afraid: KoalaAfraid,
        angry: KoalaAngry,
    },
    giraffe: {
        ok: GiraffeOk,
        excited: GiraffeExcited,
        sad: GiraffeSad,
        happy: GiraffeHappy,
        afraid: GiraffeAfraid,
        angry: GiraffeAngry,
    },
    otter: {
        ok: OtterOk,
        excited: OtterExcited,
        sad: OtterSad,
        happy: OtterHappy,
        afraid: OtterAfraid,
        angry: OtterAngry,
    },
    deer: {
        ok: DeerOk,
        excited: DeerExcited,
        sad: DeerSad,
        happy: DeerHappy,
        afraid: DeerAfraid,
        angry: DeerAngry,
    },
    bunny: {
        ok: BunnyOk,
        excited: BunnyExcited,
        sad: BunnySad,
        happy: BunnyHappy,
        afraid: BunnyAfraid,
        angry: BunnyAngry,
    },
    elephant: {
        ok: ElephantOk,
        excited: ElephantExcited,
        sad: ElephantSad,
        happy: ElephantHappy,
        afraid: ElephantAfraid,
        angry: ElephantAngry,
    },
    zebra: {
        ok: ZebraOk,
        excited: ZebraExcited,
        sad: ZebraSad,
        happy: ZebraHappy,
        afraid: ZebraAfraid,
        angry: ZebraAngry,
    },
    sugarGlider: {
        ok: SugarGliderOk,
        excited: SugarGliderExcited,
        sad: SugarGliderSad,
        happy: SugarGliderHappy,
        afraid: SugarGliderAfraid,
        angry: SugarGliderAngry,
    },
    leopard: {
        ok: LeopardOk,
        excited: LeopardExcited,
        sad: LeopardSad,
        happy: LeopardHappy,
        afraid: LeopardAfraid,
        angry: LeopardAngry,
    },
    fish: {
        ok: FishOk,
        excited: FishExcited,
        sad: FishSad,
        happy: FishHappy,
        afraid: FishAfraid,
        angry: FishAngry,
    },
    darkBear: {
        ok: DarkBearOk,
        excited: DarkBearExcited,
        sad: DarkBearSad,
        happy: DarkBearHappy,
        afraid: DarkBearAfraid,
        angry: DarkBearAngry,
    },
    kitty: {
        ok: KittyOk,
        excited: KittyExcited,
        sad: KittySad,
        happy: KittyHappy,
        afraid: KittyAfraid,
        angry: KittyAngry,
    },
    beaver: {
        ok: BeaverOk,
        excited: BeaverExcited,
        sad: BeaverSad,
        happy: BeaverHappy,
        afraid: BeaverAfraid,
        angry: BeaverAngry,
    },
    frog: {
        ok: FrogOk,
        excited: FrogExcited,
        sad: FrogSad,
        happy: FrogHappy,
        afraid: FrogAfraid,
        angry: FrogAngry,
    },
    hedgeHog: {
        ok: HedgeHogOk,
        excited: HedgeHogExcited,
        sad: HedgeHogSad,
        happy: HedgeHogHappy,
        afraid: HedgeHogAfraid,
        angry: HedgeHogAngry,
    },
    lion: {
        ok: LionOk,
        excited: LionExcited,
        sad: LionSad,
        happy: LionHappy,
        afraid: LionAfraid,
        angry: LionAngry,
    },
    lama: {
        ok: LamaOk,
        excited: LamaExcited,
        sad: LamaSad,
        happy: LamaHappy,
        afraid: LamaAfraid,
        angry: LamaAngry,
    },
    owl: {
        ok: OwlOk,
        excited: OwlExcited,
        sad: OwlSad,
        happy: OwlHappy,
        afraid: OwlAfraid,
        angry: OwlAngry,
    },
    rabbit: {
        ok: RabbitOk,
        excited: RabbitExcited,
        sad: RabbitSad,
        happy: RabbitHappy,
        afraid: RabbitAfraid,
        angry: RabbitAngry,
    },
}
